import { h, Component } from 'preact';
import detectPassiveEvents from 'detect-passive-events';

const ESCAPE = 27;

/**
 * Wraps a component and provides a manner to respond to clicks outside that component.
 */
export default class ClickOutsideDetector extends Component {

	handleKeyDown = e => {
		if (e.keyCode === ESCAPE) {
			this.props.onClickOutside && this.props.onClickOutside();
		}
	}

	/**
	 * Handle click events
	 * @param {event} e
	 */
	handleClick = e => {
		let  { target } = e;
		do {
			// Return if the target is ourself, or our child.
			if (target===this.base) return;
		} while ((target=target.parentNode));

		// If we made it here, the click was outside.
		if (this.props.onClickOutside) {
			this.props.onClickOutside(e);
		}
	};

	componentDidMount() {
		addEventListener('click', this.handleClick, true);
		addEventListener('touchstart', this.handleClick, (detectPassiveEvents.hasSupport === true ? { capture: true, passive: false } : true));
		addEventListener('keydown', this.handleKeyDown, true);
	}

	componentWillUnmount() {
		removeEventListener('click', this.handleClick, true);
		removeEventListener('touchstart', this.handleClick, (detectPassiveEvents.hasSupport === true ? { capture: true, passive: false } : true));
		removeEventListener('keydown', this.handleKeyDown, true);
	}

	render({ children }) {
		return children[0] || null;
	}
}
